import EFOcats_event_core from '../../../core/v1/event/efocats_event_core.js';

export default class EFOcats_event_retro_branch extends EFOcats_event_core {
  init() {
    this.$('section').each((index, elem) => {
      const title = this.$(elem).find('.cat-txt').html();

      if (title && title.indexOf('お届け希望日') !== -1) {
        this.$(elem).addClass('branch1');
      }

      if (title && title.indexOf('集荷希望日') !== -1) {
        this.$(elem).addClass('branch2');
      }
    });
  }

  // お届け希望日
  event() {
    this.$('section').each((index, elem) => {
      const title = this.$(elem).find('.cat-txt').html();
      if (title && title.indexOf('ダンボールサイズ') !== -1) {
        this.$(elem)
          .find('input')
          .on('change', el => {
            if (this.$(el.currentTarget).val() === '申し込みキットのみ') {
              this.$('.branch1').addClass('hidden');
            } else {
              this.$('.branch1').removeClass('hidden');
            }
          });
      }
      // 集荷希望選択
      if (title && title.indexOf('集荷希望選択') !== -1) {
        this.$(elem)
          .find('select')
          .on('change', el => {
            if (this.$(el.currentTarget).val() === 'ご自身で手配する') {
              this.$('.branch2').addClass('hidden');
            } else {
              this.$('.branch2').removeClass('hidden');
            }
          });
      }
    });
  }
}
